import classnames from '../util/classnames';
import Icon from 'src/components/Icon';
import { useTabGrouping } from './Sidebar/useTabGrouping';
import TileButton from './TileButton';
import { useIsMobile } from '../hooks/useIsMobile';
import { useDarkMode } from '../context/DarkModeContext';
import staggerDelay from '../util/staggerDelay';

const TILE_SIZE = 110;

function SwitchBoard({ className, title, tabs, groups, setActive }) {
  const { tabGroups } = useTabGrouping({ tabs: tabs ?? {}, groups, defaultGroup: 'settings' });
  const isMobile = useIsMobile();
  const { isDarkMode } = useDarkMode();

  let animIndex = 0;

  return (
    <div className={classnames('worktray p-4', className)}>
      {title && <p style={{ marginBottom: '24px' }}>{title}</p>}
      {tabGroups?.length ? (
        tabGroups.map(({ name, icon, buttons }) => (
          <div key={name} style={{ marginBottom: '32px' }}>
            <h6 className="flex align-center" style={{ marginBottom: '16px', fontWeight: '600', color: isDarkMode ? '#e2e4e9' : '#555' }}>
              {icon && <Icon icon={icon} style={{ marginRight: '8px' }} />}
              {name}
            </h6>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {buttons.map(({ tag, def: { icon, title } }, idx) => (
                <div
                  key={idx}
                  className="stagger-item"
                  style={{ animationDelay: `${staggerDelay(animIndex++)}ms`, width: isMobile ? '100%' : undefined }}
                >
                  <TileButton
                    className="btn"
                    colorKey={isDarkMode ? 'gray100' : 'primaryMain'}
                    icon={icon}
                    label={title}
                    width={isMobile ? '100%' : TILE_SIZE * 2}
                    height={isMobile ? undefined : TILE_SIZE}
                    direction={isMobile ? 'row' : 'column'}
                    padding={isMobile ? '10px 14px' : undefined}
                    onClick={() => setActive(tag)}
                  />
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <h1>No settings to show.</h1>
      )}
    </div>
  );
}

export default SwitchBoard;
